import React, { useState, useEffect } from "react";
import { Form, Input, Button, Row, Col } from "antd";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { doResetPassword } from "../../../modules/auth/stores/thunk";
import "./Auth.scss";

const isNordicrouting = window.location.origin.includes("nordicrouting.se");
const lang = isNordicrouting ? "se" : "en";

const text = {
  en: {
    createNewPassword: "Create New Password",
    createNewPasswordSubtitle: "Create a new password and login again to your account",
    password: "Password",
    required: "Required",
    invalidPassword: "Invalid password",
    passwordShouldBe: "Password should be:",
    atLeastCharacters: "At least 8 characters long",
    atLeastLowerCase: "At least one lower case",
    atLeastNumber: "At least one number",
    atLeastUpperCase: "At least one upper case",
    updatePassword: "Update Password",
  },
  se: {
    createNewPassword: "Skapa nytt lösenord",
    createNewPasswordSubtitle: "Skapa ett nytt lösenord och logga in igen på ditt konto",
    password: "Lösenord",
    required: "Obligatorisk",
    invalidPassword: "Ogiltigt lösenord",
    passwordShouldBe: "Lösenordet ska vara:",
    atLeastCharacters: "Minst 8 tecken långt",
    atLeastLowerCase: "Minst en liten bokstav",
    atLeastNumber: "Minst en siffra",
    atLeastUpperCase: "Minst en stor bokstav",
    updatePassword: "Uppdatera lösenord",
  },
};

const ResetPasswordForm = ({ history, token }) => {
  const [password, setPassword] = useState("");
  const dispatch = useDispatch();
  const { message } = useSelector(state => state.common);

  useEffect(() => {
    if (message) {
      history.push("/");
    }
  }, [message]);

  const handleSubmit = params => {
    dispatch(doResetPassword({ ...params, token }));
  };

  return (
    <div className="ResetPasswordForm">
      <Form scrollToFirstError layout="vertical" hideRequiredMark colon={false} onFinish={handleSubmit}>
        <div className="Logo">
          <Link to="/">
            <img src={`/logo-${isNordicrouting ? "nordicrouting" : "parcelizer"}.svg`} alt="logo" />
          </Link>
        </div>
        <div className="FormHeader">
          <div className="Title">{text[lang].createNewPassword}</div>
          <div className="SubTitle">{text[lang].createNewPasswordSubtitle}</div>
        </div>
        <div className="FormContent">
          <Form.Item
            label={text[lang].password}
            name="password"
            hasFeedback
            rules={[
              { required: true, message: text[lang].required },
              {
                validator(_, value) {
                  if (!value || new RegExp("^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(.{8,})$").test(value)) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error(text[lang].invalidPassword));
                },
              },
            ]}>
            <Input.Password
              size="large"
              placeholder={text[lang].password}
              onChange={e => setPassword(e.target.value)}
            />
          </Form.Item>
          <div className="HintPassword Invalid">
            <div className="HintTitle">{text[lang].passwordShouldBe}</div>
            <Row>
              <Col span={12}>
                <div className="HintItem">
                  <img src={`/icons/${/.{8,}/.test(password) ? "" : "un"}checked-circle.svg`} alt="" />{" "}
                  {text[lang].atLeastCharacters}
                </div>
                <div className="HintItem">
                  <img src={`/icons/${/[a-z]/.test(password) ? "" : "un"}checked-circle.svg`} alt="" />{" "}
                  {text[lang].atLeastLowerCase}
                </div>
              </Col>
              <Col span={12}>
                <div className="HintItem">
                  <img src={`/icons/${/\d/.test(password) ? "" : "un"}checked-circle.svg`} alt="" />{" "}
                  {text[lang].atLeastNumber}
                </div>
                <div className="HintItem">
                  <img src={`/icons/${/[A-Z]/.test(password) ? "" : "un"}checked-circle.svg`} alt="" />{" "}
                  {text[lang].atLeastUpperCase}
                </div>
              </Col>
            </Row>
          </div>
        </div>
        <div className="FormFooter">
          <Button type="primary" htmlType="submit" block size="large">
            {text[lang].updatePassword}
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default ResetPasswordForm;
